import React from "react";
export const checkdata=(data)=>{
    if(data){
        return true
    }else{
        return false
    }
}
export const formatBoldText = (text) => {
  if (!text) return "";

  return text.split("**").map((part, index) =>
    index % 2 === 0 ? (
      part.includes("Learn more at we-bc.ca") ? (
        <>
          {part.split("we-bc.ca").map((subPart, subIndex) =>
            subIndex === 0 ? (
              subPart
            ) : (
              <>
                <a
                  href="https://we-bc.ca"
                  target="_blank"
                  rel="noopener noreferrer"
                  key={`link-${index}-${subIndex}`}
                >
                 <strong>we-bc.ca</strong>
                </a>
                {subPart}
              </>
            )
          )}
        </>
      ) : (
        part
      )
    ) : (
      <>
        <strong key={index}>{part}</strong>
        <br key={`br-${index}`} />
      </>
    )
  );
};
export  const formatText = (text) => {
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {formatBoldText(line)}
        <br />
      </React.Fragment>
    ));
  };

  export const BlogsHelper = (text) => {
    if (!text) return null;
 
    const decodeHTMLEntities = (str) => {
      const parser = new DOMParser();
      const dom = parser.parseFromString(`<!doctype html><body>${str}`, 'text/html');
      return dom.body.innerHTML || ''; 
    };
  
    const processParagraph = (paragraph) => {
      const decodedParagraph = decodeHTMLEntities(paragraph);
  

      return (
        <div
          dangerouslySetInnerHTML={{ __html: decodedParagraph }}
          key={paragraph}
        />
      );
    };
  
    return (
      <div>
        {text.split('\n').map((paragraph, index) => (
          <div key={index}>{processParagraph(paragraph)}</div>
        ))}
      </div>
    );
  };
  
export const ModifyText = (text) => {
  const boldRegex = /\*\*(.*?)\*\*/g;
  text = text.replace(boldRegex, "<strong>$1</strong>");

  text = text.split("\n\n").join("<br><br>");
  text = text.split("\n").join("<br>");

    return text;

  };
  export const filterByDate = (data) => {
    const today = new Date();
    const startOfToday = new Date(today.setHours(0, 0, 0, 0));
    const startOfYesterday = new Date(new Date().setDate(today.getDate() - 1)).setHours(0, 0, 0, 0);
    const endOfYesterday = new Date(new Date().setDate(today.getDate() - 1)).setHours(23, 59, 59, 999);
    const sevenDaysAgo = new Date(new Date().setDate(today.getDate() - 7));
    const thirtyDaysAgo = new Date(new Date().setDate(today.getDate() - 30));

    const todayData = [];
    const yesterdayData = [];
    const previous7DaysData = [];
    const previous30DaysData = [];

    data.forEach((item) => {
        const createdAt = new Date(item?.createdAt);

        if (createdAt >= startOfToday) {
            todayData.push(item);
        } else if (createdAt >= startOfYesterday && createdAt <= endOfYesterday) {
            yesterdayData.push(item);
        } else if (createdAt >= sevenDaysAgo) {
            previous7DaysData.push(item);
        } else if (createdAt >= thirtyDaysAgo || createdAt < thirtyDaysAgo) {
            previous30DaysData.push(item);
        }
    });

    return {
        Today: todayData,
        Yesterday: yesterdayData,
        Previous_7_Days: previous7DaysData,
        Previous_30_Days: previous30DaysData,
    };
}